Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    calendarForegroundColor: tokens.themeForegroundPrimaryDefault,
    calendarBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    calendarSpacingInsetDay: 16,
    calendarSpacingInsetTime: 8,
    calendarBorderWidth: 1,
    calendarBorderColor: tokens.themeBorderSecondaryDefault,
    calendarDayOfWeekHeaderBorderWidth: 2,
    calendarDayOfWeekHeaderFontWeight: 600,
    calendarDayOfWeekHeaderHeight: 48,
    calendarDayOfWeekHeaderShadowColor: "rgba(11, 12, 12, 0.16)",
    calendarDayOfWeekHeaderShadowOffsetX: 0,
    calendarDayOfWeekHeaderShadowOffsetY: 2,
    calendarDayOfWeekHeaderShadowBlur: 4,
    calendarDayOfWeekHeaderShadowSpread: 0,
    calendarHourHeaderBorderWidth: 2,
    calendarHourHeaderFontWeight: 600,
    calendarHourHeaderHeight: 48,
    calendarHourHeaderShadowColor: "rgba(11, 12, 12, 0.16)",
    calendarHourHeaderShadowOffsetX: 0,
    calendarHourHeaderShadowOffsetY: 2,
    calendarHourHeaderShadowBlur: 4,
    calendarHourHeaderShadowSpread: 0,
    calendarDayBackgroundColor: tokens.themeBackgroundAlternateSecondaryDefault,
    calendarDayLabelLineHeight: "16px",
    calendarDayLabelOutsideRangeColor: tokens.themeForegroundSecondaryDefault,
    calendarDayLabelInsideRangeWeight: 600,
    calendarHourBackgroundColor: tokens.themeBackgroundAlternateSecondaryDefault,
    calendarCurrentTimeIndicatorWidth: 1,
    calendarCurrentTimeIndicatorColor: tokens.themeForegroundAccentDefault,
    calendarCurrentHeadingIndicatorColor: tokens.themeForegroundAccentDefault,
    calendarCurrentHeadingIndicatorHeight: 2,
    calendarCurrentHeadingIndicatorBorderRadius: 999,
    calendarCurrentHeadingIndicatorSpacingVertical: 6,
    calendarMotionDuration: "200ms",
    calendarMotionFunction: "ease"
  }
};